import React, { useEffect, useState } from "react";
import TalkToAnExportResourceTiles from "./TalkToAnExportResourceTiles";
import "./TalkToAnExpert.css";
import Disclaimer from "../../components/Disclaimer/Disclaimer";
import { ResourceTileClient } from "../../clients/ResourceTileClient";
import { cleanUpTiles, ContentfulTileProps } from "../../utils/contentful-helpers";

interface TaggedResourceTiles {
  data: ContentfulTileProps[];
  tagFilter: string;
}

const TalkToAnExpert = () => {
  const [taggedResourceTiles, setTaggedResourceTiles] = useState<TaggedResourceTiles[]>([]);

  useEffect(() => {
    const tagFilters = ["Pathway Mentors", "Talk to an Expert", "Mentoring Programs"];
    const requests = tagFilters.map(async (tagFilter) => {
      const data = await ResourceTileClient.getEntries({
        content_type: "resourceTile",
        "fields.tags[in]": tagFilter,
      });
      if(data.items && Array.isArray(data.items)) {
        return {
          data: data.items,
          tagFilter: tagFilter,
        }
      }
      return {
        data: [],
        tagFilter: tagFilter,
      }
    });
    Promise.all(requests).then((results) => {
      const processedResults = results.map((result) => {
        return {
          tagFilter: result.tagFilter,
          data: cleanUpTiles(result.data),
        }
      });
      setTaggedResourceTiles(processedResults);
    });
  }, []);

  const getSectionTitle = (tagFilter: string) => {
    switch (tagFilter) {
      case "Pathway Mentors":
        return "Talk More with Pathway Mentors";
      case "Talk to an Expert":
        return "Talk to an Expert at CSUF";
      case "Mentoring Programs":
        return "Find Additional Mentoring Programs";
      default:
        return tagFilter;
    }
  };

  return (
    <div className="talk-to-an-expert">
      {taggedResourceTiles.map((section) => (
        <div key={section.tagFilter}>
          <h2>{getSectionTitle(section.tagFilter)}</h2>
          <div className="start-container">
            <TalkToAnExportResourceTiles resourceTiles={section.data} />
          </div>
        </div>
      ))}
      <Disclaimer />
    </div>
  );
};

export default TalkToAnExpert;
